import { Box, Typography, styled } from "@mui/material"

export const SUBSCRIPTION_COUNT_BADGE_HEIGHT = 22

export const SubscriptionCountBadge = ({
  count,
}: {
  count: number
}) => (
  <Badge>
    <Typography variant="12px">{count}</Typography>
  </Badge>
)

const Badge = styled(Box)(({ theme: { palette, spacing } }) => ({
  display: "grid",
  placeContent: "center",
  borderRadius: "100px",
  height: `${SUBSCRIPTION_COUNT_BADGE_HEIGHT}px`,
  paddingInline: spacing(1),
  backgroundColor: palette.secondary.main,
  color: palette.common.white,
}))
